'use client';

import { Stack } from '@mantine/core';
import { LottieRefCurrentProps } from 'lottie-react';
import dynamic from 'next/dynamic';
import { useRef } from 'react';

import classNames from './Animate.module.css';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

interface AnimateProps {
  animationData: object;
  onComplete: () => void;
  loop: boolean;
  width: string;
  height: string;
}

const Animate: React.FC<AnimateProps> = ({
  animationData,
  onComplete,
  loop,
  width,
  height,
}) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  return (
    <div className={classNames.loaderContainer}>
      <Stack
        gap="md"
        align="center"
      >
        <Lottie
          lottieRef={lottieRef}
          animationData={animationData}
          loop={loop}
          onComplete={onComplete}
          style={{ width, height }}
        />
      </Stack>
    </div>
  );
};

export { Animate };
